import type { TargetingDefinition } from '../../models';

export interface PreDecoratedRule {
  [key: string]: PreDecoratedRuleTerm | string | undefined;
  id?: string;
  definition?: PreDecoratedRuleTerm;
}

export interface PreDecoratedRuleTerm {
  'sub-class'?: string;
  not?: boolean;
  'term-list'?: PreDecoratedRuleTerm[];
  'value-set'?: string[];
  dimension?: string;
  'range-list'?: Range[];
}

export enum ProviderEntryFilterMatchMethodEnum {
  CONTAINS = 'CONTAINS',
  STARTS_WITH = 'STARTS_WITH',
  WORD_STARTS_WITH = 'WORD_STARTS_WITH',
  ENDS_WITH = 'ENDS_WITH',
}

export enum ProviderEntryFilterIdSpaceEnum {
  PROVIDER = 'PROVIDER',
  SOURCE = 'SOURCE',
}

export enum ProviderEntrySourceSystemEnum {
  THE_R = 'THE_R',
  ALEXANDRIA = 'ALEXANDRIA',
  MIDGUARD = 'MIDGUARD',
  FONZI_DB = 'FONZI_DB',
  SELF = 'SELF',
  CMP = 'CMP',
  DEVICE_SERVICE = 'DEVICE_SERVICE',
  LOCATION_SERVICE = 'LOCATION_SERVICE',
  IPSE = 'IPSE',
}

export interface PaginationMetadata {
  first: string | null;
  next: string | null;
  prev: string | null;
  last: string | null;
}

export interface ProviderEntryAttributeMap {
  publisher?: string;
  country?: string;
  premiereDateTime?: string; // ISO 8601 formatted date string
  salesChannel?: string[];
  sportId?: string;
  sportName?: string;
}

interface ProviderEntrySource {
  id: string;
  name: string;
  system: ProviderEntrySourceSystemEnum;
  source?: string;
}

export interface ProviderEntryBase {
  id: string;
  primarySource: ProviderEntrySource;
  additionalSources: ProviderEntrySource[];
  attributeMap: ProviderEntryAttributeMap;
}

interface ProviderEntryMap {
  map: Record<string, ProviderEntryBase>;
  lastUpdatedAt: string; // ISO 8601 timestamp
}

export interface ProviderEntryMapResponse {
  data: ProviderEntryMap;
  links: PaginationMetadata;
}

interface ProviderEntryFilter {
  matchMethod?: ProviderEntryFilterMatchMethodEnum;
  target?: string;
  idSet?: string[];
  idSpace?: ProviderEntryFilterIdSpaceEnum;
  // accessRule?: Rule;
  targetSet?: string[];
}

interface UiTargetingTerm {
  dimensionId: string;
  valueId: string;
  include: boolean;
  // Deferred: Preset preset;
}

export interface RuleFilterTerm {
  subClass: string;
  not: boolean;
  dimension: string;
  valueSet: string[];
}

export interface RuleFilterDefinition {
  subClass: string;
  not: boolean;
  termList: RuleFilterTerm[];
}

export interface RuleFilter {
  definition: RuleFilterDefinition;
}

export interface UiProviderEntryDimensionValuesFilter {
  [key: string]: ProviderEntryFilter | UiTargetingTerm[] | RuleFilter | undefined;
  dimensionFilter?: ProviderEntryFilter;
  valuesFilter?: ProviderEntryFilter;
  uiTargetingTermList?: UiTargetingTerm[];
  ruleFilter?: RuleFilter;
}

export interface TargetingValuesResponse {
  nodes: Array<TargetingDefinition>;
  pageInfo: {
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
}

export interface FetchTargetingValuesResults {
  data: TargetingValuesResponse | undefined;
  loading: boolean;
  loadingMore: boolean;
  error?: string;
  refetch: (append?: boolean) => Promise<void>;
  reset: () => void;
  hasMore: boolean;
}
